(function ($, document) {

    function ShowConfirmation(qty) {

        basketUrl = $('[data-basket-confirmation-modal]').attr('data-basketUrl');

        confirmationModel = '<div class="basket-confirmation__row" data-basket-confirmation-modal-content>'
            + '<div class="basket-confirmation__content">'
            + '<span>Your basket has been updated</span>'
            + '<a class="button basket-confirmation__button" href="' + basketUrl + '">View basket</a>'
            + '</div>'
            + '</div>'
            ;

        $(confirmationModel)
            .appendTo('[data-basket-confirmation-modal]')
            .delay(2000)
            .queue(function (e) {
                $(this).addClass('fade-out');
                e();
                setTimeout(function () {
                    $('[data-basket-confirmation-modal-content]').remove();
                }, 2000);
            })
            ;
    }

    function ShowErrorMessage(message) {
        alert(message);
    }

    function EnsureBasketTextFieldsAreValid() {
        $(document).on('keypress', '[data-basket-qty]', function (e) {
            var a = [];
            var k = e.which;
            for (i = 48; i < 58; i++)
                a.push(i);
            if (!($.inArray(k, a) >= 0)) {
                e.preventDefault();
            }
        });

        $(document).on('input', '[data-basket-qty]', function (e) {
            var $input = $(this);
            var txtVal = $input.val();
            if (txtVal.length > 3) {
                txtVal = txtVal.substring(0, txtVal.length - 1);
                $input.val(txtVal)
            }
            if (typeof $input.data('max-quantity') !== 'undefined') {
                var maxQty = $input.data('max-quantity') - 0;
                if (($input.val() - 0) > maxQty) {
                    $input.val(maxQty);
                }
            }

            if (typeof UpdatePage_HasChanged == 'function') {
                UpdatePage_HasChanged();
            }
        });
    }

    function EnsureWithdrawalFormsAreInitialized() {
        $(document).on('click', '.js-basket-withdraw', function (e) {
            e.preventDefault();
            var $item = $(this);
            var $qty = $($item.data('quantity-input'));
            var $field = $item.parent('.js-withdraw-container');

            var desiredQty = $qty.val() - 0;
            if (desiredQty > 0) {
                var url = '/api/withdrawals/add';
                var itemInformation = {
                    'payload': $item.data('identifier'),
                    'quantity': desiredQty
                };

                $field
                    .removeClass('js-withdraw-container')
                    .removeClass('resSellAction')
                    .html('<div class="reserves-notification">' + $item.data('msg-withdrawn') + '</div>');

                var request = $
                    .ajax({
                        url: url,
                        data: JSON.stringify(itemInformation),
                        method: 'POST',
                        context: desiredQty,
                        contentType: "application/json"
                    })
                    .done(function (result) {
                        if (result.IsSuccessful) {
                            ShowConfirmation(desiredQty);
                            window.LayWheeler.Basket.UpdateSummary();
                        } else {
                            ShowErrorMessage(result.Warnings);
                        }
                    })
                    ;
            }
        });
    }


    function UpdateBasketFormMessaging($priceContainer, desiredQty ) {

        var $basketMessage = $priceContainer.find('[data-basket-msg]');

        if ($basketMessage.length) {
            var currentQtyInBasket = $basketMessage.attr("data-current-quantity");
            currentQtyInBasket = (currentQtyInBasket - 0) + desiredQty;

            $basketMessage
                .html(currentQtyInBasket + " in basket")
                .attr("data-current-quantity", currentQtyInBasket)
            ;
            $(document).foundation('equalizer', 'reflow');
        }
    }

    function EnsureBasketFormsAreInitialized() {
        $(document).on('click', '[data-basket-form-button]', function (e) {
            e.preventDefault();
            var $item = $(this);
            var $priceContainer = $item.parents('[data-basket-form]');

            var $qty = $priceContainer.find('[data-basket-qty]');

            var desiredQty = $qty.val() - 0;
            if (desiredQty > 0) {
                var url = '/api/basket/add';
                var itemInformation = {
                    'payload': $item.data('basket-form-identifier'),
                    'quantity': desiredQty
                };

                var defaultProductData, newProductData;

                try {
                    defaultProductData = document.GetDefaultProductDataLayer($item);
                    if (typeof defaultProductData !== 'undefined'
                        && defaultProductData !== null) {
                        defaultProductData.quantity = desiredQty;
                    }

                    newProductData = document.GetNewProductDataLayer($item);
                    if (typeof newProductData !== 'undefined'
                        && newProductData !== null) {
                        newProductData.quantity = desiredQty;
                    }
                }
                catch (err) { }

                UpdateBasketFormMessaging($priceContainer, desiredQty);

                var request = $
                    .ajax({
                        url: url,
                        data: JSON.stringify(itemInformation),
                        method: 'POST',
                        context: desiredQty,
                        contentType: "application/json"
                    })
                    .done(function (result) {
                        if (result.IsSuccessful) {

                            try {
                                document.UpdateDefaultDataLayerOnAddToCart(defaultProductData);
                                document.UpdateNewDataLayerOnAddToCart(newProductData);
                            }
                            catch (err) { }

                            if ($item.data('basket-redirect')) {
                                window.location.href = "/legacy-basket";
                            } else {
                                if ($item.data('loading') && $item.hasClass('disabled')) {
                                    window.DisableLoading($item);
                                }

                                if (window.location.href.includes("/basket")) {
                                    window.location.reload(false);
                                } else {
                                    ShowConfirmation(desiredQty);
                                    window.LayWheeler.Basket.UpdateSummary();
                                }
                            }
                        } else {
                            ShowErrorMessage(result.Warnings);
                        }
                    });
            } else {
                if ($item.data('loading') && $item.hasClass('disabled')) {
                    window.DisableLoading($item);
                }
            }
        });
    }

    $(document).ready(function () {
        EnsureBasketTextFieldsAreValid();
        EnsureWithdrawalFormsAreInitialized();
        EnsureBasketFormsAreInitialized();
    });
})(jQuery, document);